module.exports = __webpack_public_path__ + "static/media/prancheta.a13a416d.svg";